import { Select } from "antd";

import { appLinks, organisationTypes, queryKeys } from "../../../config/constants";
import EmptyDisplayComponent from "../Empty";
import useLookupsSearch from "./useLookupsSearch";

const { Option } = Select


const PlaymomentLookup = (props) => {

    const { organisationId, ...rest} = props

    const link = appLinks.challengesLookup.replace('{organisationId}', organisationId);

    const { 
        data = [],
        isLoading,
        onSearch,
        onBlur,
    } = useLookupsSearch(
        link,
        [queryKeys.challengesLookup, organisationId],
        { type: organisationTypes.foundation }
    )

    return (
        <Select
            mode="multiple"
            labelInValue
            tagRender={EmptyDisplayComponent}
            loading={isLoading}
            // search related
            filterOption={false} // needed to pick items updated after search
            showSearch
            showArrow
            onSearch={onSearch}
            onBlur={onBlur}
            {...rest}
        >
            {
                data?.map(item => (<Option key={item.value} value={item.value}>{item.label}</Option>))
            }
        </Select>
    )

}

export default PlaymomentLookup;